<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
#app {
  width: 100%;
  height: 100%;
  -ms-overflow-style: none;
  margin: 0;
  padding: 0;
  font-family: "Microsoft YaHei",serif;
  text-align: center;
}
html,body {
  width: 100%;
  height: 100%;
  -ms-overflow-style: none;
}
/*自定义滚动条颜色*/
::-webkit-scrollbar {
  width: 6px;
  height: 5px;
  background-color: transparent;
}
/*定义滚动条轨道 内阴影+圆角*/
::-webkit-scrollbar-track {
  background-color: transparent;
}
</style>



// WEBPACK FOOTER //
// src/App.vue